export class Tipos_Contrato
{
    public id_tpct: number = 0;
    public desc_tpct: string = '';
    public conteudo_tpct: string = '';
    public situacao_tpct: string = ' ';
    public exclusao_tpct: boolean = false;
}